export const Loader = () => (
  <div className="flex flex-row gap-2">
    <div className="size-4 animate-bounce rounded-full bg-primary" />
    <div className="size-4 animate-bounce rounded-full bg-primary [animation-delay:.3s]" />
    <div className="size-4 animate-bounce rounded-full bg-primary" />
  </div>
);
